import React from 'react';
import { Card, Grid, makeStyles, Typography } from '@material-ui/core';
// import { Chip } from "common";

import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  contentContainer: {
    display: 'flex',
    padding: '5px 20px 5px 10px',
    textAlign: 'left',
    height: 'calc(100vh - 325px)',
    overflow: 'scroll',
    background: '#fff',
  },
}));

const useCaptionValueStyles = makeStyles(() => ({
  captionValueContainer: {
    borderRadius: 2,
    backgroundColor: '#f7f7f7',
    width: 'calc(100% - 24px)',
    padding: 12,
    marginBottom: 8,
  },
  caption: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: '20px',
    letterSpacing: 0.25,
    textAlign: 'left',
    color: '#9ca8b5',
  },
  value: {
    fontWeight: 500,
    color: '#49515a',
  },
}));

const useSectionStyles = makeStyles(() => ({
  cardContainer: {
    padding: 16,
    borderRadius: 2,
    boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.11)',
  },
  cardTitle: {
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: '20px',
    letterSpacing: 0.24,
    textAlign: 'left',
    color: '#9ca8b5',
    marginBottom: 16,
    display: 'flex',
    alignItems: 'center',

    '& > svg': {
      width: 18,
      height: 18,
      paddingRight: 10,
    },
  },
  fieldsContainer: {
    paddingLeft: 26,
  },
}));

const CaptionValueField = ({ caption = '', value = '' }) => {
  const classes = useCaptionValueStyles();

  const formattedValue =
    typeof value === 'string' ? value.trim() || '-' : value;

  return (
    <div className={classes.captionValueContainer}>
      <Typography className={classes.caption}>{caption}</Typography>
      {typeof formattedValue === 'object' ? (
        Object.keys(formattedValue).map((k) => (
          <CaptionValueField
            caption={
              k.match(/[A-Z][a-z]+/g) ? k.match(/[A-Z][a-z]+/g).join(' ') : k
            }
            value={formattedValue[k]}
          />
        ))
      ) : (
        <Typography className={clsx(classes.caption, classes.value)}>
          {formattedValue}
        </Typography>
      )}
    </div>
  );
};

const SectionTitleContainer = ({ title = '', Icon, children }) => {
  const classes = useSectionStyles();

  return (
    <Grid item xs={12}>
      <Card className={classes.cardContainer}>
        <Typography className={classes.cardTitle}>
          {Icon ? <Icon /> : <></>} {title}
        </Typography>
        {children}
      </Card>
    </Grid>
  );
};

const KeyValueSection = ({ keyValuePairs = [] }) => {
  const classes = useSectionStyles();

  return (
    <div className={classes.fieldsContainer}>
      {keyValuePairs.map(({ key, value }) => (
        <CaptionValueField caption={key} value={value} />
      ))}
    </div>
  );
};

const ExpenseOverview = ({ json = {} }) => {
  const classes = useStyles();

  const { rows, ...jsonContent } = json;
  const keyValuePairs = Object.keys(jsonContent)
    .map((k) => ({
      key: k.match(/[A-Z][a-z]+/g) ? k.match(/[A-Z][a-z]+/g).join(' ') : k,
      value: json[k],
    }))
    .filter((kv) => kv.value || kv.value === 0 || kv.value === '0');

  return (
    <>
      <div className={classes.contentContainer}>
        <Grid container spacing={4}>
          <SectionTitleContainer title={'Document Schema'}>
            <KeyValueSection keyValuePairs={keyValuePairs} />
          </SectionTitleContainer>
        </Grid>
      </div>
    </>
  );
};

export default ExpenseOverview;
